import { Toaster as SonnerToaster } from "sonner"

export function Toaster() {
  return (
    <SonnerToaster
      position="top-right"
      toastOptions={{
        style: {
          background: "hsl(222 28% 13%)",
          border: "1px solid hsl(222 20% 20%)",
          color: "hsl(220 20% 92%)",
        },
      }}
    />
  )
}
